import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, nextTick, watch, computed } from 'vue';
import AnimateText from '../AnimateText.vue';
import useMainStore from '../../main.store';
export default /*@__PURE__*/_defineComponent({
  __name: 'FriendlyReminder',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const mainStore = useMainStore();
    const props = __props;
    const text = computed(() => {
      try {
        return props.content.tips;
      } catch {
        return props.content;
      }
    });
    const AnimateTextRef = ref();
    const typeWriter = async () => {
      await nextTick();
      AnimateTextRef.value?.typeWriter(text.value);
    };
    function handleEnd() {
      mainStore.loadNextMsg(props.item);
    }
    watch(() => props.item.openAnimate, newVal => {
      if (newVal) {
        typeWriter();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(AnimateText, {
        text: __props.item.openAnimate ? '' : text.value,
        ref_key: "AnimateTextRef",
        ref: AnimateTextRef,
        onEnd: handleEnd
      }, null, 8, ["text"]);
    };
  }
});